const optimizationCaseEn = {
	optimizationCaseTable: 'Optimization Case',
	optimizationCaseEditForm: 'Optimization Case',
	optimizationCase: 'Optimization Case',
	name: 'Name',
	basic: 'Basic',
	domains: 'Domains',
	optimizer: 'Optimizer',
	optimizer_log_name: 'Optimizer Log Name',
	optimizer_log_file: 'Optimizer Log File',
	objective_name: 'Objective Name',
	objective_file: 'Objective File',
	domain_from: 'Domain From',
	domain_to: 'Domain To',
	stepCount: 'Step Count',
	run: 'Futtatás',
	runDesc: 'Do you want to run this case?',
	optimizerLog: 'Optimizer Log',
	'optimizerLog.name': 'Optimizer Log',
	'optimizer.name': 'Optimizer',
	'aspect.name': 'Aspect',
	'transformer.name': 'Transformer',
	operator: 'Operator',
	aspectName: 'Aspect name',
	objectiveName: 'Objective name',
	type: 'Típus',
	value: 'Érték',
	minValue: 'Min. érték',
	maxValue: 'Max. érték',
	state: 'State',
	values: 'Values',
	reader: 'Reader',
	imputedValue: 'Imputed value',
	optimizationGoal: 'Optimization goal',
	enabled: 'Enabled',
	load_aspect: 'Load Aspect',
	aspect: 'Aspect',
	limits: 'Limits',
	'soft.type': 'Soft Type',
	'soft.low': 'Soft Low',
	'soft.high': 'Soft High',
	'soft.value': 'Soft Value',
	'hard.type': 'Hard Type',
	'hard.low': 'Hard Low',
	'hard.high': 'Hard High',
	'hard.value': 'Hard Value',
	transformerName: 'Transformer name',
	stepLimit: 'Step limit',
	stateLimits: 'State limits',
	aspectLimits: 'Aspect limits',
	transformerLimits: 'Transformer limits',
	transformer_attributes: 'Transformer inject',
	boundaryType: 'Boundary Type',
	boundary: 'Boundary',
	factor: 'Factor',
	bias: 'Bias',
	transformer: 'Transformer',
	outputKey: 'Output key',
	userGroup: 'User Group'
};

export default optimizationCaseEn;
